/* unplugin-vue-components disabled */import { render } from "./buy.vue?vue&type=template&id=2e29e5f0&scoped=true"
import script from "./buy.vue?vue&type=script&lang=js"
export * from "./buy.vue?vue&type=script&lang=js"

import "./buy.vue?vue&type=style&index=0&id=2e29e5f0&scoped=true&lang=css"

import exportComponent from "D:\\WorkPlace\\官网\\html-bcepd-project-website-digital-read\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e29e5f0"]])

export default __exports__